// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__F60-c","title":"card_title__3vqbh","inActive":"card_inActive__1olfu"};